import { render, staticRenderFns } from "./InvitationsButtons.vue?vue&type=template&id=f08a17f8"
import script from "./InvitationsButtons.vue?vue&type=script&lang=js"
export * from "./InvitationsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports